import { Application } from '../../../Models/Application';

export enum ApplicationsActionType {
  REQUEST_APPLICATIONS = 'REQUEST_APPLICATIONS',
  RECEIVE_APPLICATIONS = 'RECEIVE_APPLICATIONS',
}

export type ApplicationsAction = IReceiveApplicationsAction | IRequestApplicationsAction;

export interface IRequestApplicationsAction {
  type: ApplicationsActionType.REQUEST_APPLICATIONS;
}

export interface IReceiveApplicationsAction {
  type: ApplicationsActionType.RECEIVE_APPLICATIONS;
  applications: Application[];
}
